// src/utils/schedule.ts
export function toISODate(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).toISOString().split('T')[0];
  }
  export function makeISO(dateISO, hhmm) {
    if (!dateISO || !hhmm) return null;
    const [y, mo, d] = dateISO.split('-').map(Number);
    const [hh, mm] = hhmm.split(':').map(Number);
    return new Date(y, mo - 1, d, hh, mm, 0, 0).toISOString();
  }
  export function humanLabel(dateISO, hhmm) {
    if (!dateISO || !hhmm) return 'Now';
    const [y, mo, d] = dateISO.split('-').map(Number);
    const [hh, mm] = hhmm.split(':').map(Number);
    const local = new Date(y, mo - 1, d, hh, mm);
    return local.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
  }
  export function generateSlotsDay(){
    // 00:00 through 23:00
    return Array.from({ length: 24 }, (_, h) => `${String(h).padStart(2, '0')}:00`);
  }
  export function format12h(hhmm) {
    const [hStr, mStr] = hhmm.split(':');
    const h = parseInt(hStr, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${h12}:${mStr} ${ampm}`; // e.g., "12:00 AM", "1:00 PM", "11:00 PM"
  }